import CommissionSection from "../../../../components/propertyDescription/CommissionSection";
import {
  emptyCommissionForm,
  type PropertyCommissionForm,
} from "../../../../utils/propertyCommission";
import { useEditPropertyWizard } from "../EditPropertyWizardContext";

export default function EditCommissionSection() {
  const { commission, formErrors, setCommission, setFormErrors } =
    useEditPropertyWizard();

  const value: PropertyCommissionForm = commission ?? emptyCommissionForm();

  return (
    <CommissionSection
      value={value}
      errors={{
        admin_percentage: formErrors.admin_percentage,
        first_rent_commission_7cantos_percentage:
          formErrors.first_rent_commission_7cantos_percentage,
        partner_name: formErrors.partner_name,
        partner_first_rent_commission_percentage:
          formErrors.partner_first_rent_commission_percentage,
      }}
      onChange={(next) => {
        setCommission(next);
        setFormErrors((current: Record<string, string>) => {
          const {
            admin_percentage: _admin,
            first_rent_commission_7cantos_percentage: _first,
            partner_name: _partner,
            partner_first_rent_commission_percentage: _partnerPct,
            ...rest
          } = current;
          return rest;
        });
      }}
    />
  );
}
